module.exports = __webpack_public_path__ + "media/images/gifts/autonomy/sug_autonomia_3-7dd7cf0c4f2bc13370c12502e5124eb3.jpg";